import { IRoutingProvider } from './routing.interface';
import { GoogleRoutingProvider } from './providers/google.provider';
import { MapboxRoutingProvider } from './providers/mapbox.provider';
import { RoutingProviderType } from './routing.types';

// Export des types et interfaces
export * from './routing.types';
export * from './routing.interface';
export * from './polyline.utils';

// Export des providers pour usage direct si nécessaire
export { GoogleRoutingProvider } from './providers/google.provider';
export { MapboxRoutingProvider } from './providers/mapbox.provider';

/**
 * Provider actif basé sur la configuration
 */
const ROUTING_PROVIDER: RoutingProviderType =
  (process.env.REACT_APP_ROUTING_PROVIDER as RoutingProviderType) || 'google';

/**
 * Instance singleton du provider de routing
 */
let routingProviderInstance: IRoutingProvider | null = null;

/**
 * Factory pour obtenir le provider de routing configuré
 * @returns Instance du provider de routing
 */
export function getRoutingProvider(): IRoutingProvider {
  if (routingProviderInstance) {
    return routingProviderInstance;
  }

  switch (ROUTING_PROVIDER) {
    case 'mapbox':
      routingProviderInstance = new MapboxRoutingProvider();
      break;
    case 'google':
    default:
      routingProviderInstance = new GoogleRoutingProvider();
      break;
  }

  console.log(`[Routing] Using provider: ${routingProviderInstance.name}`);
  return routingProviderInstance;
}

/**
 * Réinitialise l'instance du provider (utile pour les tests)
 */
export function resetRoutingProvider(): void {
  routingProviderInstance = null;
}

/**
 * Retourne le nom du provider actuellement configuré
 */
export function getRoutingProviderName(): RoutingProviderType {
  return ROUTING_PROVIDER;
}
